var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { class: { mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("GiftPlans"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("GiftReviews", { staticClass: "section" }),
          _vm._v(" "),
          _c("BrilliantAudience", { staticClass: "section" }),
          _vm._v(" "),
          !_vm.isMobile(_vm.$mq)
            ? _c("PaywallFeaturesList", { staticClass: "section" })
            : _c("PaywallSimpleFeaturesList", { staticClass: "section" }),
          _vm._v(" "),
          _c("PaywallCoursesList", { staticClass: "section" })
        ],
        1
      ),
      _vm._v(" "),
      _c("GiftPaywallFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }